(function () {
  'use strict';

  function resolveRoute(href, base, config) {
    if (!href || /^(#|mailto:|tel:|javascript:)/i.test(href)) return null;
    let source;
    try { source = new URL(href, base); } catch (_) { return null; }
    if (!/^https?:$/.test(source.protocol)) return null;
    const baseUrl = new URL(base);
    const origins = new Set([baseUrl.origin, ...(config.origins || [])]);
    if (!origins.has(source.origin)) return null;
    const path = source.pathname.match(/^(.*\/)collections\/([^/]+)\/?$/);
    if (!path || path[2] === 'all') return null;
    const route = config.routes.find(item => item.routable && (item.key === path[2] || (item.aliases || []).includes(path[2])));
    if (!route) return null;
    const target = new URL(route.url, baseUrl);
    target.pathname = path[1] + 'collections/all';
    if (source.searchParams.has('filter.p.product_type')) target.searchParams.delete('filter.p.product_type');
    for (const [key, value] of source.searchParams) {
      if (key !== 'page' && key !== 'ho_tree_page') target.searchParams.append(key, value);
    }
    target.hash = source.hash;
    return target;
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { resolveRoute };
  if (typeof document === 'undefined') return;
  const data = document.getElementById('ho-shop-routing-data');
  if (!data) return;
  let config;
  try { config = JSON.parse(data.textContent); } catch (_) { return; }
  if (!Array.isArray(config.routes)) return;

  function rewrite(root) {
    const anchors = root.matches?.('a[href]') ? [root] : [];
    anchors.push(...(root.querySelectorAll?.('a[href]') || []));
    for (const anchor of anchors) {
      if (anchor.hasAttribute('download') || anchor.hasAttribute('data-ho-route-original')) continue;
      const original = anchor.getAttribute('href');
      const target = resolveRoute(original, location.href, config);
      if (!target) continue;
      anchor.dataset.hoRouteOriginal = original;
      anchor.setAttribute('href', target.pathname + target.search + target.hash);
    }
  }

  const current = new URL(location.href);
  const redirected = resolveRoute(current.href, current.href, config);
  if (redirected && !window.Shopify?.designMode && !current.searchParams.has('section_id') && !current.searchParams.has('sections')) {
    location.replace(redirected.href);
    return;
  }
  rewrite(document);
  const observer = new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType === 1) rewrite(node);
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
